<template>
  <customize-header class="page-login"
                    v-ym-report:LOGIN_PAGE_EXPOSURE=""
  >
    <template #header>
      <top-bar show-header>
        <template #header-right>
          <div class="login-header-right"
               @click="passwordLogin = !passwordLogin"
          >
            {{ passwordLogin ? '验证码登录' : '密码登录' }}
          </div>
        </template>
      </top-bar>
    </template>
    <login-header :password-login="passwordLogin" />
    <div v-if="passwordLogin"
         class="form"
    >
      <ym-field class="form-field password-login"
                model="whole-line"
                clearable
                v-model.trim="username"
                placeholder="请输入用户名/手机号"
                :attr="{ autocomplete: false }"
                @keyup.enter.prevent="handleSubmit"
      />
      <div class="field">
        <ym-field class="form-field password-login"
                  :class="{ 'password-small': !eye }"
                  model="whole-line"
                  v-model.trim="password"
                  :type="eye ? 'text' : 'password'"
                  placeholder="请输入密码"
                  :attr="{ autocomplete: false }"
                  @keyup.enter.prevent="handleSubmit"
        />
        <ym-icon class="field-icon"
                 :name="eye ? 'yanjing1' : 'biyanjing1'"
                 color="#999"
                 size="20px"
                 @click="eye = !eye"
        />
      </div>
      <div class="link-container">
        <router-link class="link"
                     :to="{ name: 'MobileVerify', query: { type: 'forgetPassword' } }"
        >忘记密码？
        </router-link>
      </div>
      <ym-button class="form-btn"
                 type="primary"
                 size="large"
                 :disabled="disabled"
                 v-ym-report:LOGIN_LOGIN_BUTTON_CLICK=""
                 @click.prevent="handleSubmit"
      >登录
      </ym-button>
    </div>
    <div v-else
          class="form"
    >
      <ym-field class="form-field"
                v-model.trim="mobile"
                model="whole-line"
                maxlength="11"
                type="tel"
                placeholder="请输入手机号"
                clearable
      />
      <div class="form-desc">未注册的手机号将自动创建账户</div>
      <ym-button class="form-btn"
                 type="primary"
                 size="large"
                 :disabled="mobile.length !== 11"
                 @click="handleSendSms"
      >
        发送验证码
      </ym-button>
      <div class="form-hint">
        <ym-img class="icon"
                :src="hintCheck
                 ? require('@/assets/img/default/login_icon_checked.png')
                 : require('@/assets/img/default/login_icon_check.png')"
                @click="hintCheck = !hintCheck"
        />
        <div class="desc">
          已阅读并同意
          <router-link :to="{ name: 'UserTerm' }">
            《服务协议》
          </router-link>
        </div>
      </div>
    </div>
    <wechat-login v-if="isWeiXin"
                  v-show="showWechatLogin"
                  type="login"
    />
  </customize-header>
</template>

<script>
  import { Field, Button } from '@ymba/ym-ui';
  import { mapActions } from 'vuex';
  import {
    getAuth,
    getQuery,
    getStorageRedirect,
    isWeiXinBrowser,
    locationHref,
    locationPath,
    getFromLocalStorage,
    removeFromLocalStorage,
  } from '@/utils';
  import { getAgencyLoginPath } from '@/services/user';
  import validator from '@/utils/validator';
  import WechatLogin from '@/pages/Login/components/WechatLogin';
  import LoginHeader from '@/pages/Login/components/LoginHeader';
  import TopBar from '@/components/TopBar';
  import CustomizeHeader from '@/layout/CustomizeHeaderLayout';

  export default {
    name: 'PageLogin',
    metaInfo: {},
    components: {
      'ym-field': Field,
      'ym-button': Button,
      WechatLogin,
      LoginHeader,
      TopBar,
      CustomizeHeader,
    },
    data() {
      return {
        username: '',
        password: '',
        submitDisabled: false,
        isRelative: true,
        isAbsolute: true,
        passwordLogin: false,
        mobile: '',
        hintCheck: false,
        eye: false,
        showWechatLogin: true,
      };
    },
    computed: {
      query() {
        return getQuery(this.$route.query);
      },
      agency() {
        return this.query && this.query.agency ? parseInt(this.query.agency, 10) : 0;
      },
      showAgencyErrorModal() {
        return this.query && this.query.showAgencyErrorModal
          ? parseInt(this.query.showAgencyErrorModal, 10) : 0;
      },
      disabled() {
        return this.username === '' || this.password === '' || this.submitDisabled;
      },
      isWeiXin() {
        return isWeiXinBrowser();
      },
    },
    methods: {
      ...mapActions([
        'Login',
        'Logout',
      ]),
      async handleSubmit() {
        if (validator.isEmpty(this.username)) {
          this.$toast('请填写用户名/手机号');
          return;
        }
        if (validator.isEmpty(this.password)) {
          this.$toast('请填写密码');
          return;
        }
        this.submitDisabled = true;
        try {
          const data = await this.Login({
            username: this.username,
            password: this.password,
            agency: this.agency,
          });
          if (this.agency === 1 && data.showAgencyErrorModal && data.showAgencyErrorModal === 1) {
            this.handleAgencyErrorModal(1);
            return;
          }
          if (this.agency === 1 && data.path && data.path !== '') {
            locationHref(data.path);
            return;
          }
          const { redirectTo } = this.query;
          const path = getStorageRedirect(redirectTo);
          locationPath(path, 1);
          this.submitDisabled = false;
          removeFromLocalStorage('last-login-mobile');
        } catch (e) {
          this.submitDisabled = false;
        }
      },
      async handleConfirmClick() {
        await this.Logout();
        this.submitDisabled = false;
        this.$router.replace({ name: 'Login', query: { agency: 1 } });
      },
      handleCancelClick() {
        this.$router.replace({ name: 'Home' });
      },
      handleAgencyErrorModal(flag = 0) {
        if (this.showAgencyErrorModal === 1 || flag === 1) {
          this.$dialog.confirm({
            title: '温馨提示',
            message: '你当前账号暂无权限登陆分销平台',
            confirmButtonText: '切换账号',
            cancelButtonText: '返回首页',
            closeOnClickOverlay: false,
          }).then(() => {
            this.handleConfirmClick();
          }).catch(() => {
            this.handleCancelClick();
          });
        }
      },
      handleSendSms() {
        if (!this.hintCheck) {
          this.$toast('请先阅读并勾选相关协议');
          return;
        }
        if (!validator.isMobile(this.mobile)) {
          this.$toast('请输入正确的手机号');
          return;
        }
        this.$router.push({
          name: 'MobileVerifyBySMS',
          query: {
            mobile: this.mobile,
            type: 'login',
            redirectTo: this.query.redirectTo,
          },
        });
      },
      handleShowWechatLogin() {
        const pageHeight = document.body.scrollHeight;
        window.onresize = () => {
          this.showWechatLogin = document.body.scrollHeight >= pageHeight;
        };
      },
    },
    mounted() {
      this.$nextTick(() => {
        this.handleShowWechatLogin();
        this.handleAgencyErrorModal();
        const mobile = getFromLocalStorage('last-login-mobile');
        if (mobile) {
          this.mobile = mobile;
          this.username = mobile;
        }
      });
    },
    async beforeRouteEnter(to, from, next) {
      const auth = getAuth();
      if (!auth) {
        next();
        return;
      }
      if (to.query && to.query.agency && parseInt(to.query.agency, 10) === 1) {
        if (to.query.showAgencyErrorModal && parseInt(to.query.showAgencyErrorModal, 10) === 1) {
          next();
          return;
        }
        const data = await getAgencyLoginPath(parseInt(to.query.agency, 10));
        if (data.showAgencyErrorModal && data.showAgencyErrorModal === 1) {
          next({ path: '/login?agency=1&showAgencyErrorModal=1' });
        } else if (data.path && data.path !== '') {
          locationHref(data.path);
        }
        return;
      }
      let { path } = from;
      if (!path) path = '/';
      next({
        path,
      });
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-login {
    min-height: 100%;
    background-color: @color-white;
    position: relative;
    box-sizing: border-box;
  }

  .login-header-right {
    color: @color-text-lighter;
    font-size: @font-size-base;
  }

  .form {
    box-sizing: border-box;
    padding: 0 50px;
    .field {
      position: relative;
      .field-icon {
        position: absolute;
        top: 50%;
        right: 10px;
      }
    }
    &-field {
      margin-bottom: 20px;
      /deep/ .ym-field-content-area {
        color: @color-black-dark;
        font-size: 46px;
        font-weight: @font-weight-bold;
        caret-color: #02cccc;
      }
      /deep/ ::placeholder {
        color: @color-gray-light;
        font-size: @font-size-medium;
        font-weight: @font-weight-primary;
      }
      &.password-login {
        margin-top: -44px;
        margin-bottom: 30px;
      }
      &.password-small {
        /deep/ .ym-field-content-area {
          font-size: 30px;
        }
      }
    }
    &-desc {
      color: @color-text-light;
      font-size: @font-size-small;
      margin-bottom: 120px;
    }
    &-btn {
      margin-bottom: @size-medium;
      border-radius: 25px;
      font-size: @font-size-medium;
      font-weight: @font-weight-bold;
      background-color: #02cccc;
      border: none;
      &.is-disabled {
        opacity: 1;
        background-color: @color-text-disabled;
      }
    }
    &-hint {
      display: flex;
      align-items: center;
      justify-content: center;
      .icon {
        width: 46px;
        height: 46px;
        margin-right: 8px;
      }
      .desc {
        color: @color-text-light;
        font-size: @font-size-small;
        a {
          color: #576b95;
        }
      }
    }
    .link-container {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 90px;
      .link {
        color: #576b95;
        font-size: @font-size-base;
        line-height: 1;
      }
    }
  }
</style>
